// @ts-nocheck
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function Profile() {
    const { user } = useAuth();
    const [form, setForm] = useState({
        name: user?.name || '',
        phone: user?.phone || '',
        address: user?.address || '',
        nid: user?.nid || '',
    });
    const [msg, setMsg] = useState('');
    const [pwd, setPwd] = useState({ currentPassword: '', newPassword: '' });

    const saveProfile = async (e) => {
        e.preventDefault();
        try {
            await api.put('/auth/profile', form);
            setMsg('Profile updated');
            const u = { ...user, ...form };
            localStorage.setItem('rems_user', JSON.stringify(u));
        } catch (err) {
            setMsg(err.response?.data?.message || 'Failed');
        }
    };

    const changePwd = async (e) => {
        e.preventDefault();
        try {
            await api.put('/auth/change-password', pwd);
            setMsg('Password changed');
            setPwd({ currentPassword: '', newPassword: '' });
        } catch (err) {
            setMsg(err.response?.data?.message || 'Failed');
        }
    };

    return (
        <div>
            <h4 className="mb-4">My Profile</h4>
            {msg && <div className="alert alert-info py-2">{msg}</div>}
            <div className="row g-4">
                <div className="col-lg-6">
                    <div className="card table-card">
                        <div className="card-header bg-white fw-semibold">Personal Info</div>
                        <div className="card-body">
                            <form onSubmit={saveProfile}>
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input className="form-control" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input className="form-control" value={user?.email} disabled />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Phone</label>
                                    <input className="form-control" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Address</label>
                                    <textarea className="form-control" rows={2} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">NID</label>
                                    <input className="form-control" value={form.nid} onChange={(e) => setForm({ ...form, nid: e.target.value })} />
                                </div>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card table-card">
                        <div className="card-header bg-white fw-semibold">Change Password</div>
                        <div className="card-body">
                            <form onSubmit={changePwd}>
                                <div className="mb-3">
                                    <label className="form-label">Current Password</label>
                                    <input type="password" className="form-control" value={pwd.currentPassword} onChange={(e) => setPwd({ ...pwd, currentPassword: e.target.value })} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">New Password</label>
                                    <input type="password" className="form-control" value={pwd.newPassword} onChange={(e) => setPwd({ ...pwd, newPassword: e.target.value })} required />
                                </div>
                                <button type="submit" className="btn btn-primary">Update Password</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
